import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

// Import all sponsor logos
import advantage from '../imgs/sponsers/advantage.png';
import canine from '../imgs/sponsers/canine.png';
import equity from '../imgs/sponsers/equity200x127.png';
import macs from '../imgs/sponsers/macs200x127.png';
import mlc from '../imgs/sponsers/mlc200x197.png';
import pacificlife from '../imgs/sponsers/pacificlife200x127.png';
import parkstone from '../imgs/sponsers/parkstone.png';
import screamingfrog from '../imgs/sponsers/screamingfrog200x127.png';
import schwing from '../imgs/sponsers/scwing-stetter.jpg';
import sultan from '../imgs/sponsers/sultan200x127.png';
import termalcomp from '../imgs/sponsers/termalcomp200x127.png';
import totalorthodontics from '../imgs/sponsers/totalorthodontics.jpg';
import glentworth from '../imgs/sponsers/U10glentworth.jpg';
import parkhall from '../imgs/sponsers/U16Parkhallco.jpg';
import vellichor from '../imgs/sponsers/vellichor200x127.png';
import yardley from '../imgs/sponsers/yardley.png';

const sponsors = [
  advantage, canine, equity, macs, mlc, pacificlife, parkstone, screamingfrog,
  schwing, sultan, termalcomp, totalorthodontics, glentworth, parkhall, vellichor, yardley
];

const Sponsors: React.FC = () => {
  return (
    <Container className="text-center mt-5">
      <h2 className="mb-4" style={{ color: '#254E97' }}>OUR SPONSORS</h2>
      <Row className="g-4 align-items-center">
        {sponsors.map((logo, index) => (
          <Col key={index} xs={6} md={4} lg={3}>
            <div className="sponsor-logo-container">
              <Image src={logo} alt={`Sponsor ${index + 1}`} fluid />
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Sponsors;